import { DropdownContent } from '@anm/components/Dropdown';
import { LEFTBAR_BOTTOM_PADDING } from '@anm/styles/constants';
import styled, { css } from 'styled-components';

import UserInfo, { UserEmailInfo } from '../../../UserBlock/UserInfo';
import UserBlockWrapper from '../../../UserBlock/Wrapper';

export const DropdownButtonWrapper = styled.div`
  top: 100%;
  z-index: 200;
  position: sticky;
  bottom: ${LEFTBAR_BOTTOM_PADDING};
  ${DropdownContent} {
    width: 100%;
    max-width: initial;
  }
`;

const itemStyles = css`
  color: var(--gray_500);
  font-weight: bold;
  &:hover {
    background-color: var(--white);
    color: var(--gray_900);
  }
`;

export const DropdownContentItem = styled.div``;
export const LogoutButtonWrapper = styled.li``;

export const DropdownContentWrapper = styled.ul`
  ${DropdownContentItem}, &&& ${LogoutButtonWrapper} {
    a,
    span {
      ${itemStyles};
    }
  }
`;

export const UserBlockContainer = styled.div`
  ${UserBlockWrapper} {
    padding: 0;
    border: 0 none;
    margin: 0 8px;
  }
  ${UserInfo} {
    color: var(--gray_500);
    cursor: pointer;
    margin-left: 8px;
    width: calc(100% - 48px);
    font-weight: bold;
  }
  ${UserEmailInfo} {
    display: none;
  }
`;
